import { ChannelType, Channel, Product, ProductSpec, ProductCategory, Warehouse, Fault, Group, AuthItemsService, ReceiveType, ProduceFactory } from '@/services/resources'
import { AuthItemType } from '@/services/const'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      // 渠道类型
      mxChannelTypes: [],
      // 渠道列表
      channelList: [],
      // 产品
      mxProducts: [],
      // 产品类型
      mxProductCategory: [],
      // 产品型号
      mxProductSpec: [],
      // 返修次数
      mxRepairCount: [1, 2, 3, 4, 5],
      // 仓库
      mxWarehouses: [],
      // 父级故障
      mxParentFaults: [],
      // 用户群组
      mxUserGroups: [],
      // 角色
      mxRoles: [],
      // 授理类型
      receiveTypes: [],
      // 生产工厂
      produceFactories: []
    }
  },
  computed: {
    ...mapGetters(['settings'])
  },
  methods: {
    /**
     * 获取渠道类型
     */
    async loadChannelType () {
      let resp = await ChannelType.query()
      this.mxChannelTypes = resp.data
    },
    /**
     * 获取渠道列表
     */
    async loadChannelList (params) {
      let resp = await Channel.query(params)
      this.channelList = resp.data
    },
    /**
     * 获取产品类型
     */
    async loadProductCategory () {
      let resp = await ProductCategory.query()
      this.mxProductCategory = resp.data
    },
    /**
     * 产品
    */
    async loadProducts (parmas) {
      let resp = await Product.query(parmas)
      this.mxProducts = resp.data
    },
    /**
     * 获取产品型号
    */
    async loadProductSpec (params) {
      let resp = await ProductSpec.query(params)
      this.mxProductSpec = resp.data
    },
    /**
     * 获取仓库
     */
    async loadWarehouses () {
      let resp = await Warehouse.query()
      this.mxWarehouses = resp.data
    },
    /**
     * 父级故障列表
     */
    async loadParentFaults () {
      let resp = await Fault.query({ 'per-page': 9999, 'page': 1, 'grade': 1 })
      this.mxParentFaults = resp.data
    },
    /**
     * 用户群组
     */
    async loadUserGroups () {
      let resp = await Group.query({ 'per-page': 9999, 'page': 1 })
      this.mxUserGroups = resp.data
    },
    /**
     * 角色
     */
    async loadRoles () {
      let resp = await AuthItemsService.query({ 'per-page': 9999, 'page': 1, type: AuthItemType.Role })
      this.mxRoles = resp.data
    },
    /**
     * 授理类型
     */
    async loadReceiveTypes () {
      let resp = await ReceiveType.query({ 'per-page': 9999, 'page': 1 })
      this.receiveTypes = resp.data
    },
    /**
     * 生产工厂
     */
    async loadProduceFatories () {
      let resp = await ProduceFactory.query({ 'per-page': 9999, 'page': 1 })
      this.produceFactories = resp.data
    }
  }
}
